module.exports = require("replaceall");